import { useCallback, useMemo, useState } from "react";

import {
  Box,
  Grid,
  Text,
  // List,
  HStack,
  VStack,
  ListItem,
  CircularProgress,
  List,
  useDisclosure,
  // CircularProgress,
} from "@chakra-ui/react";

import { useHistory } from "react-router-dom";

//Components
import Button from "components/Button/Button";
import InvestWallet from "components/InvestWallet/InvestWallet";
import CoinPerformance from "components/CoinPerformance/CoinPerformance";
// import PaymentDueGauge from "components/PaymentDueGauge/PaymentDueGauge";
import PriceChart from "components/Charts/PriceChart";

// import { ReactComponent as HistoryMeter } from "assets/svg/history-meter.svg";
// import { ReactComponent as PerformanceChart } from "assets/svg/inpl-chart.svg";
import { ReactComponent as EmptyTransactionState } from "assets/svg/empty-inpl.svg";

import {
  // useGetLoanRecordsQuery,
  // useGetLoanBalanceQuery,
  useGetEarnWalletQuery,
  useGetStakingsQuery,
  // useGetLoanProfileQuery,
} from "services/walletApi";

import { useGetCoinToUsdRateQuery } from "services/rateApi";

// import isEmpty from "lodash/isEmpty";
import toLower from "lodash/toLower";
import { format, parseISO } from "date-fns";
// import formatter from "util/formatter";
// import toUpper from "lodash/toUpper";
// import take from "lodash/take";
import StakedAmount from "components/StakedAmount/StakedAmount";
import { toQueryString } from "util/utils";
import { take } from "lodash";
import toPrecision from "util/toPrecision";
import Confirmation from "components/Modals/p2p/Confirmation";

export const TransactionItem = ({
  coin,
  unit,
  status,
  description,
  value,
  createdAt,
  isLast,
  onClick,
}) => {
  // const { isOpen, onClose /*onOpen*/ } = useDisclosure();

  // const { data, isLoading } = useGetLoanBalanceQuery();

  const colors = useMemo(() => {
    const map = {
      active: {
        color: "#F4B740",
        // label: `Requested a loan of ${currencyValue} worth ${coin}`,
      },
      rolledover: {
        color: "#F4B740",
        // label: `Requested a loan of ${currencyValue} worth ${coin}`,
      },
      cancelled: {
        color: "#ED2E7E",
        // label: `Cancelled requested loan of ${currencyValue} worth ${coin}`,
      },
      denied: {
        color: "#ED2E7E",
        // label: `Your Loan requested of ${currencyValue} worth ${coin} was denied`,
      },
      redeemed: {
        color: "var(--primary)",
        // label: `Your Loan requested of ${currencyValue} worth ${coin} is currently being processed`,
      },
      terminated: {
        color: "#bb0404",
        // label: `Active running loan of ${currencyValue} worth ${coin}`,
      },
      paid: {
        color: "#03A438",
        // label: `You paid out loan of ${currencyValue} worth ${coin}`,
      },
      defaulted: {
        color: "#ED2E7E",
        // label: `User Defaulted for loan of ${currencyValue} worth ${coin} is currently being processed`,
      },
    };

    return map[toLower(status) ?? "active"];
  }, [status]);

  return (
    <>
      <ListItem
        w="100%"
        as={Button}
        minH="fit-content"
        bg="transparent"
        // bg="#FCFCFC"
        p="32px 0"
        borderRadius="2px"
        borderBottom={!isLast ? "1px solid #EAEAEA" : "none"}
        _hover={{ bg: "transparent" }}
        _active={{ bg: "transparent" }}
        _focus={{ bg: "transparent", shadow: "0 0 0 3px var(--focusColor)" }}
        onClick={onClick}
      >
        <HStack justifyContent="space-between" w="100%" px="4px">
          <HStack alignItems="flex-start">
            <Box
              mt="6px !important"
              borderRadius="50%"
              boxSize="10px"
              bg={colors?.color}
            />
            <Box maxW="250px">
              <Text
                textAlign="left"
                fontSize="sm"
                fontWeight="500"
                color="#595B67"
                w="100%"
                whiteSpace="nowrap"
                textOverflow="ellipsis"
                overflow="hidden"
                m="0 !important"
              >
                {description}
              </Text>
              <Text textAlign="left" fontSize="12px" mt="2px" color="#A0A3BD">
                {format(parseISO(createdAt), "eee, dd MMM yyyy, HH:mm")}
              </Text>
            </Box>
          </HStack>

          <Text color="#4E4B66" fontSize="14px" fontWeight="600">
            {/* {toLower(type) === "debit" ? "-" : ""} */}
            {/* {formatter(currency).format(currencyValue)} {toUpper(currency)} */}
            {toPrecision(value?.$numberDecimal, unit)}
            {/* $50 */}
          </Text>
        </HStack>
      </ListItem>
    </>
  );
};

function NoTransactions() {
  return (
    <VStack py="80px">
      <Box as={EmptyTransactionState} />
      <Text fontSize="14px" color="#6E7191">
        No transactions to display!
      </Text>
    </VStack>
  );
}

export default function ParialBCPL({ coin, availableCoins }) {
  const maxHistoryLength = 14;
  const history = useHistory();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [state, setState] = useState({ coin });

  const handleState = (newState) => setState({ ...state, ...newState });

  // const { data } = useGetLoanRecordsQuery();
  // const { data: loanProfile } = useGetLoanProfileQuery();

  const queries = useMemo(
    () =>
      toQueryString({
        unit: state?.coin,
        // status: filter === "all" ? null : filter,
        actionType: "staking_in,staking_out",
        limit: 20,
        // actionType: "staking_in",
      }),
    [state?.coin]
  );

  const { data, isLoading } = useGetStakingsQuery(queries);

  const { data: earnData, isLoading: isLoadingWallets } =
    useGetEarnWalletQuery();

  const earnings = useMemo(() => data?.records, [data]);

  const wallets = useMemo(() => earnData?.wallets, [earnData]);

  const selectedWallet = useMemo(
    () => state?.coin && wallets?.find((w) => w?.unit === state?.coin),
    [state?.coin, wallets]
  );

  const isInsufficientBalance = useMemo(
    () => (+selectedWallet?.balance?.$numberDecimal ?? 0) <= 0,
    [selectedWallet]
  );

  console.log("Earn Data", earnData, selectedWallet, isInsufficientBalance);
  // console.log("Earnings", earnings);
  // console.log("queries", queries);

  //   console.log("HISTORY DATA", data);

  const coinName = useCallback((coin = "btc") => {
    const map = {
      [coin]: coin,
      tbtc: "btc",
      teth: "eth",
    };

    return map[coin];
  }, []);

  // const { data: loanBalanceData } = useGetLoanBalanceQuery();

  // console.log("LOAN BALANCE", loanBalanceData);

  // const isBalanceLoaded = useRef(false);

  // const loans = useMemo(() => data?.loans, [data]);

  // const runningLoan = useMemo(
  //   () => loans?.find((loan) => loan?.loanStatus === "running"),
  //   [loans]
  // );

  // console.log("RUNNING LOAN", runningLoan);

  const { data: rates, isFetching } = useGetCoinToUsdRateQuery(
    coinName(state?.coin)
  );

  // const loanBalance = useMemo(() => {
  //   const values = loanBalanceData?.arraySums[0];
  //   return values;
  // }, [loanBalanceData]);

  // const canRequestLoan = useMemo(() => {
  //   if (isEmpty(loans ?? [])) return false;
  //   return !!!loans?.find(
  //     (loan) => loan?.loanStatus === "running" || loan?.loanStatus === "pending"
  //   );
  // }, [loans]);

  // useEffect(() => {
  //   if (!coin) {
  //     if (loanBalance && !isBalanceLoaded.current) {
  //       handleState({ coin: coinName(loanBalance?.coin) });
  //       isBalanceLoaded.current = true;
  //     }
  //   }

  //   // eslint-disable-next-line
  // }, [coin, loanBalance, isBalanceLoaded]);

  const handleEarnNow = () => {
    if (isInsufficientBalance) {
      onOpen();
      return;
    }
    history.push(`/dashboard/earn/subscribe?coin=${state?.coin}`);
    return;
  };

  console.log("STATE", state);

  return (
    <Grid
      templateColumns={["1fr", "1fr", "repeat(2, 1fr)"]}
      mt="32px"
      gap="20px"
    >
      <Box
        bg="white"
        // border="1px solid #8688942f"
        // minH="681px"
        //   w="calc(100% - 25vw)"
        // w="fit-content"
        borderRadius="16px"
        overflow="hidden"
        shadow="0px 8px 24px rgba(154, 170, 207, 0.15)"
        // p="48px"
      >
        <Box p="38px">
          <InvestWallet
            label="Earn Wallet"
            isLoading={isLoadingWallets}
            balance={selectedWallet?.balance?.$numberDecimal}
            coin={state?.coin}
            availableCoins={availableCoins}
            // isPaybackDisabled={
            //   state?.coin !== loanBalance?.coin || !runningLoan
            // }
            // isRequestDisabled={!canRequestLoan}
            buttonText={["Transfer Funds", "Earn Now"]}
            onSelect={(value) => handleState({ coin: value })}
            // onRequest={() =>
            //   history.push(`/dashboard/earn/earnings?coin=${state?.coin}`)
            // }
            // onPayback={() =>
            //   history.push(`/dashboard/earn/transfer/${state?.coin}`)
            // }

            actions={[
              {
                label: "Transfer Funds",
                onClick: () =>
                  history.push(`/dashboard/earn/transfer/${state?.coin}`),
              },
              {
                label: "Earn Now",
                onClick: handleEarnNow,
              },
            ]}
          />

          <StakedAmount
            variant="stake"
            amount={selectedWallet?.amountAtStake?.volume}
            coin={state?.coin}
          />

          <StakedAmount
            variant="info"
            amount={0.0034556}
            coin={state?.coin}
            onClick={() =>
              history.push(`/dashboard/earn/earnings/${state?.coin}`)
            }
          />

          <CoinPerformance
            isFetching={isFetching}
            coin={state?.coin ?? "btc"}
            price={rates?.exchangeRate?.buy ?? 0}
            mt="42px"
          />
        </Box>
        {/* <Box w="100%" mt="60px" as={PerformanceChart} /> */}
        <PriceChart coin={state?.coin} mt="10px" />
      </Box>

      <Box
        bg="white"
        // border="1px solid #8688942f"
        borderRadius="16px"
        shadow="0px 8px 24px rgba(154, 170, 207, 0.15)"
        // minH="681px"
        //   w="calc(100% - 25vw)"
        // w="fit-content"
        p="48px"
      >
        <Box>
          <HStack justifyContent="space-between">
            <Text fontSize="18px" color="#14142B" fontWeight="700">
              History
            </Text>

            {earnings?.length > maxHistoryLength && (
              <Button
                variant="ghost"
                bg="transparent"
                minW="fit-content"
                color="var(--primary)"
                size="sm"
                // onClick={() => history.push(`/dashboard/bcpl/history`)}
              >
                View all
              </Button>
            )}
          </HStack>

          {!isLoading && earnings?.length < 1 && <NoTransactions />}
          {/* <NoTransactions /> */}

          {isLoading && (
            <VStack py="100px">
              <CircularProgress
                ml="20px !important"
                isIndeterminate
                color="var(--primary)"
                size="20px"
              />
            </VStack>
          )}

          {earnings?.length > 0 && !isLoading && (
            <List w="100%" py="10px !important">
              {take(earnings, maxHistoryLength)?.map((earning, i) => (
                <TransactionItem
                  {...earning}
                  key={`earning-item-${i}`}
                  onClick={() =>
                    history.push(
                      `/dashboard/earn/earnings/${earning?.unit}/${earning?._id}`
                    )
                  }
                />
              ))}
            </List>
          )}
        </Box>
      </Box>

      <Confirmation
        isOpen={isOpen}
        onClose={onClose}
        title="Insufficient funds"
        buttonText={["Cancel", "Fund"]}
        onConfirm={() => {
          history.push(
            `/dashboard/earn/transfer/${state?.coin}?continue=/dashboard/earn/subscribe?coin=${state?.coin}`
          );
        }}
      >
        <Text>
          You have an insufficient fund. Fund your earn wallet to preceed.
        </Text>
      </Confirmation>
    </Grid>
  );
}
